import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDataElement } from 'src/app/models/interface/template/templateDataElement';
import { MAP_TARGET_TEMPLATE_STATUS } from 'src/app/utils/Constants';

@Component({
  selector: 'app-dialog-change-template-status',
  templateUrl: './dialog-change-template-status.component.html',
  styleUrls: ['./dialog-change-template-status.component.scss']
})
export class DialogChangeTemplateStatusComponent implements OnInit {

  translatedStatus: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TemplateDataElement,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getTargetStatus();
  }

  private getTargetStatus() {
    const currentStatus = this.data.element.isActive;
    const status = MAP_TARGET_TEMPLATE_STATUS['' + currentStatus];
    this.translateStatus(status);
  }

  private translateStatus(status: string) {
    this.translate.get('TEMPLATES_STATUS.' + status).subscribe((translated: string) => {
      this.translatedStatus = translated;
    });
  }

}
